<template>
  <span class="holiday-deal-badge">Holiday Deal</span>
</template>

<script>
export default {
  name: 'HolidayDealBadge'
}
</script>

<style scoped>
/* Holiday Deal badge — grey pill, red text, tag icon. Temporary holiday-sale variant. */
.holiday-deal-badge {
  display: inline-flex;
  align-items: center;
  gap: 4px;
  margin-top: 3px;
  margin-bottom: 6px;
  background-color: #e9e9e9;
  color: #ff4c46;
  font-family: var(--satoshi, 'Satoshi', sans-serif);
  font-size: 12px;
  font-weight: 500;
  line-height: 20px;
  letter-spacing: normal;
  text-transform: none;
  padding: 0 6px;
  height: 20px;
  border-radius: 4px;
  white-space: nowrap;
  pointer-events: none;
}

.holiday-deal-badge::before {
  content: "";
  width: 16px;
  height: 16px;
  flex: 0 0 auto;
  background: url('~@/assets/images/icon_tag.svg') center / contain no-repeat;
}
</style>
